export default __webpack_public_path__ + "static/media/TITULOS_03.ada694ca.png";